okeReviewsWidgetOnInit = function () {
    const reviewTab = document.querySelector('.reviews_tab a');
    const reviewStar = document.querySelector('.summary-inner .js-okeReviews-reviewsSummary');
    if (reviewStar && reviewTab) {
        reviewStar.onclick = function () {
            reviewTab.click();
        };
    }
}